import { Box, DialogBody, FormatNumber, HStack, LocaleProvider, Separator, Spinner, Stack, Table, Text } from "@chakra-ui/react";
import { UI } from "components";
import useAnticipation from "hooks/useAnticipation";
import moment from "moment";

export default function Anticipation({ data, ...props }){

    const anticipation = useAnticipation(data?.id)
    const career = data?.career

    return(
    <UI.Dialog title={`Antecipação de ${career?.title}`} size="md" {...props}>
        <DialogBody>
            <Stack gap={4}>

                <UI.Show visible={anticipation.isFetching}><UI.Alert indicator={<Spinner />}>Carregando dados da antecipação...</UI.Alert></UI.Show>

                <Box>
                    <Text color="GrayText" mb={2}>Total de pontos antecipados:</Text>
                    <Text fontSize="3xl" fontWeight="bold" color="orange.fg"><UI.Number.Number value={anticipation.data?.points} /></Text>
                </Box>

                <HStack gap={4}>
                    <Box>
                        <Text color="GrayText" mb={2}>Pontos qualificáveis:</Text>
                        <Text fontSize="lg" fontWeight="bold" color="green.fg"><UI.Number.Number value={anticipation.data?.qualified} /></Text>
                    </Box>

                    <Box>
                        <Text color="GrayText" mb={2}>Acima da VME:</Text>
                        <Text fontSize="lg" fontWeight="bold" color="red.fg"><UI.Number.Number value={anticipation.data?.overflow} /></Text>
                    </Box>
                </HStack>

                <Separator />

                <Table.Root size="sm" variant="outline">
                    <Table.Header>
                        <Table.Row>
                            <Table.ColumnHeader>Downline</Table.ColumnHeader>
                            <Table.ColumnHeader>Pontos</Table.ColumnHeader>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {anticipation.data?.itens?.map(item => {
                            return(
                            <Table.Row key={item.downline.cod}>
                                <Table.Cell fontSize="xs">{item.downline?.customer?.name ?? 'Usuário Expirado'}</Table.Cell>
                                <Table.Cell color="orange.fg"><LocaleProvider locale="de-DE"><FormatNumber value={(item.qualified_points + item.overflow_points) / 100} /></LocaleProvider> pontos</Table.Cell>
                            </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table.Root>

                <Box>
                    <Text color="GrayText" mb={2}>Data da antecipação:</Text>
                    <Text>{moment(anticipation.data?.created_at).format('LLL')}</Text>
                </Box>

                <Box>
                    <Text color="GrayText" mb={2}>Tipo de antecipação:</Text>
                    <Text>{anticipation.data?.type === 1 ? 'Antecipado pelo sistema' : 'Antecipado pelo consultor'}</Text>
                </Box>

                <Box>
                    <Text color="GrayText">ID da antecipação:</Text>
                    <Text fontSize="xs" color="GrayText">{anticipation.data?.id}</Text>
                </Box>

            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}